var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"schedule-report-modal","title":"Schedule Report","size":"xl","hide-footer":""},on:{"show":_vm.setFormData}},[_c('GraphQLFormEdit',{ref:"schedule-form",attrs:{"formType":"schedule","redirects":false},on:{"formSaved":_vm.afterSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }